import { GET_PROFILE } from '../actions/profile.action'

const initState = {
  profile: null
}

const profileReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_PROFILE:
      return {
        ...state,
        profile: action.payload.profile
      }
    default:
      return state
  }
}

export default profileReducer
